export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        //
        // Tabs
        //
        let buttonTabClass = 'subscription-landing-page-hero__mobile-tab--active';
        let panelTabClass = 'subscription-landing-page-hero__mobile-panel--active';
        $('#mobile-tab-one').click(() => {
            $('#mobile-tab-one').addClass(buttonTabClass);
            $('#mobile-tab-two').removeClass(buttonTabClass);
            $('#mobile-panel-one').addClass(panelTabClass);
            $('#mobile-panel-two').removeClass(panelTabClass);
        });

        $('#mobile-tab-two').click(function () {
            $('#mobile-tab-one').removeClass(buttonTabClass);
            $('#mobile-tab-two').addClass(buttonTabClass);
            $('#mobile-panel-one').removeClass(panelTabClass);
            $('#mobile-panel-two').addClass(panelTabClass);
        });

        //
        // Bottom Slider
        //
        $('.subscription-landing-page-first-panel__bottom-slider .swiper').each(function (item, value) {
            // console.log('hello world abc 123');
            new window.Swiper(
                value,
                {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    centeredSlides: true,
                    slideToClickedSlide: false,
                    // keyboard control
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: '.subscription-landing-page-first-panel__bottom-control--next',
                        prevEl: '.subscription-landing-page-first-panel__bottom-control--prev',
                    },
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                        570: {
                            spaceBetween: 16,
                            slidesPerView: 'auto',
                        },
                        750: {
                            spaceBetween: 16,
                            slidesPerView: 'auto',
                        },
                        1040: {
                            spaceBetween: 32,
                            slidesPerView: 'auto',
                        },
                        1280: {
                            spaceBetween: 32,
                            slidesPerView: 'auto',
                        },
                    },
                }
            );
        });

        //
        // Bottom Slider
        //
        $('.subscription-landing-page-second-panel__bottom-slider .swiper').each(function (item, value) {
            // console.log('hello world abc 123');
            if (jQuery(value).find('.swiper-slide').length < 2) {
                new window.Swiper(
                    value,
                    {
                        loop: true,
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                        centeredSlides: true,
                        slideToClickedSlide: false,
                        // keyboard control
                        keyboard: {
                            enabled: true,
                        },
                        observer: true,
                        observeParents: true,
                        breakpoints: {
                            570: {
                                spaceBetween: 16,
                                slidesPerView: 'auto',
                            },
                            750: {
                                spaceBetween: 16,
                                slidesPerView: 'auto',
                            },
                            1040: {
                                spaceBetween: 32,
                                slidesPerView: 'auto',
                            },
                            1280: {
                                spaceBetween: 32,
                                slidesPerView: 'auto',
                            },
                        },
                    }
                );
            }
        });
    },
};
